export default __webpack_public_path__ + "static/media/skrill.901ab70e.svg";